module.exports = __webpack_public_path__ + "img/noble4.e4ab1874.png";